/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withRouter } from 'react-router-dom';

import {
    object, shape, string, array, func,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isRetailOrSale from '../../../../../helpers/isRetailOrSale';
import { trackEvent as trackEventAction } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getActiveABTests } from '../../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';

const styles = (theme) => ({
    root: {
        boxShadow: '0 2px 3px rgba(59,33,81,0.15), 0 2px 2px rgba(59,33,81,0.15)',
        border: `1px solid ${theme.palette.colorPrimary}`,
        margin: '10px 0',
        position: 'relative',
        borderRadius: '3px',
        width: '100%',
        minWidth: '440px',
        maxWidth: '600px',
        [theme?.breakpoints?.down('md')]: {
            maxWidth: '100%',
            minWidth: '100%',
        },
    },
    smartGiftContainer: {
        background: theme.palette.colorNeutral30 || '#eee',
        border: 'inherit',
    },
    mobileContainer: {
        margin: '10px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        '& svg': {
            fontSize: 34,
            fill: 'currentColor',
            color: theme.palette.colorPrimary,
            width: '1em',
        },
    },
    smartGiftMobileContainer: {
        margin: '10px 24px',
    },
    smartGiftButton: {
        width: '100%',
        border: `1px solid ${theme.palette.colorPrimary}`,
        cursor: 'pointer',
        margin: '10px 0',
        display: 'flex',
        padding: '8px 30px',
        fontSize: '16px',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        '& svg': {
            fontSize: 24,
        },
    },
    smartGiftNewButton: {
        border: 'none',
        margin: '16px 0',
        padding: '14px 30px',
        fontSize: '15px',
        borderRadius: 4,
        background: theme.palette.colorPrimary,
    },
    buttonTitle: {
        marginLeft: 5,
    },
    buttonNewTitle: {
        fontWeight: 700,
        color: theme.palette.white || '#fff',
        margin: 0,
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    title: {
        flex: '1 0 50%',
        margin: '0 0 0 10px',
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        justifyContent: 'space-around',
        fontSize: 14,
    },
});

const  GraphqlSmartGiftUIMobile = ({
    classes, mobileGiftData, location, productName, sku, price, image, activeABTests, trackEvent,
}) => {
    const cartSvg = () => (
        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
            <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" />
            <path fill="none" d="M0 0h24v24H0z" />
        </svg>
    );
    const smartGiftRedesign =  activeABTests?.pdp_smart_gift_widget === 'VARIANT';
    const smartGiftSend = () => {
        const categoryId = location?.state?.categoryId;
        const pathname = location?.pathname;

        trackEvent({
            eventCategory: 'Product Page',
            eventAction: 'Smart Gift Click',
            eventLabel: productName,
        });

        if (typeof window !== 'undefined' && window.SGBasket) {
            window.SGBasket.addItem({
                skuCode: sku.match(/[^-_]*$/)[0], // '(string | required ) the unique identifier of the sku',
                skuUrl: pathname, // '(string | required ) the current PDP URL',
                price: isRetailOrSale(price), // '(float | required) the price of the SKU',
                name: productName, // '(string | required) The name of the product',
                image, // '(string | required) The image url of the product',
                quantity: '1.0',
                customParameters: {
                    categoryId,
                    source: 'smg',
                    SCILocNumber: '',
                }, // '(object | Optional) the custom parameters as in key-value pairs',
            });
        }
    };
    if (!mobileGiftData) {
        return null;
    }

    return  (
        <div
            className={smartGiftRedesign ? `${classes.root} ${classes.smartGiftContainer}` : classes.root}
            data-testid="smart-gift-ui-mobile"
        >
            <div className={smartGiftRedesign ? `${classes.mobileContainer} ${classes.smartGiftMobileContainer}` : classes.mobileContainer}>
                <div className={classes.icon}>
                    {cartSvg()}
                </div>
                <div
                    style={{ color: mobileGiftData.font_color }}
                    className={classes.title}
                    data-testid="smart-gift-mobile-copy"
                >
                    {mobileGiftData.copy}
                </div>
                <button type="button" onClick={smartGiftSend} className={smartGiftRedesign ? `${classes.smartGiftButton} ${classes.smartGiftNewButton}` : classes.smartGiftButton}>
                    {!smartGiftRedesign && cartSvg()}
                    <span className={smartGiftRedesign ? `${classes.buttonTitle} ${classes.buttonNewTitle}` : classes.buttonTitle}>{mobileGiftData.link?.title}</span>
                </button>
            </div>
        </div>
    );
};

GraphqlSmartGiftUIMobile.propTypes = {
    classes: object.isRequired,
    location: shape({
        state: shape({
            categoryId: string,
        }),
    }),
    productName: string.isRequired,
    sku: string.isRequired,
    price: array.isRequired,
    image: string.isRequired,
    mobileGiftData: shape({
        copy: string,
        font_color: string,
        link: shape({
            title: string,
        }),
    }),
    trackEvent: func.isRequired,
    activeABTests: object.isRequired,
};

GraphqlSmartGiftUIMobile.defaultProps = {
    location: {
        state: {},
    },
    mobileGiftData: {},
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(trackEventAction, dispatch),
});
const mapStateToProps = (state) => ({
    activeABTests: getActiveABTests(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),

);

export default enhance(GraphqlSmartGiftUIMobile);
